import { faApple } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Disclosure, DisclosureButton, Labeled } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiGetResourcesResponseBody } from '~/lib/api/modules/AppResources';
import { FormSection } from '~/components/atoms/FormSection';
import { AssetUploader } from '~/components/organisms/fields/AssetUploader';

export type IAssetsSettingsFormIosSectionProps = IContainerProps & {
  appId: string;
  assets: IApiGetResourcesResponseBody;
};

export const AssetsSettingsFormIosSection: React.FC<
  IAssetsSettingsFormIosSectionProps
> = (props) => {
  const { sx, appId, assets } = props;
  const { t } = useTranslation();

  return (
    <Disclosure
      sx={sx}
      defaultExpanded
      trigger={
        <DisclosureButton leadingIcon={<FontAwesomeIcon icon={faApple} />}>
          iOS
        </DisclosureButton>
      }
    >
      <FormSection sub>
        <Labeled label={t('AssetsSettingsFormIosSection.fields.icon.label')}>
          {(elementProps) => (
            <AssetUploader
              appId={appId}
              type="ios"
              format="icon"
              accept={{ 'image/png': ['.png'] }}
              acceptWidth={{ min: 1024 }}
              acceptHeight={{ min: 1024 }}
              supportingText={t(
                'AssetsSettingsFormIosSection.fields.icon.dropZoneSupportingText',
              )}
              downloadUrl={assets.platforms?.ios?.appIcon?.downloadUrl}
              {...elementProps}
            />
          )}
        </Labeled>
        <Labeled
          label={t('AssetsSettingsFormIosSection.fields.splashScreen.label')}
        >
          {(elementProps) => (
            <AssetUploader
              appId={appId}
              type="ios"
              format="splash"
              accept={{ 'image/png': ['.png'] }}
              acceptWidth={{ min: 2732 }}
              acceptHeight={{ min: 2732 }}
              supportingText={t(
                'AssetsSettingsFormIosSection.fields.splashScreen.dropZoneSupportingText',
              )}
              downloadUrl={assets.platforms?.ios?.splashScreen?.downloadUrl}
              {...elementProps}
            />
          )}
        </Labeled>
      </FormSection>
    </Disclosure>
  );
};
